import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 sm:py-24 px-4 bg-padel-surface relative" data-id="element-188">
      <div className="max-w-3xl mx-auto" data-id="element-189">
        <FadeIn data-id="element-190">
          <div className="prose prose-invert prose-lg sm:prose-xl max-w-none" data-id="element-191">
            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-192">
              Hay algo que ningún profe de pádel dice en voz alta pero que casi
              todos sienten.
            </p>
            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-193">
              No es que no saben enseñar.
            </p>
            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-194">
              No es que no les gusta lo que hacen.
            </p>
            <p className="text-gray-300 leading-relaxed mb-8" data-id="element-195">
              Es algo más incómodo que eso.
            </p>

            <div className="bg-padel-dark border-l-4 border-padel-lime p-6 sm:p-8 rounded-r-xl mb-10 shadow-lg" data-id="element-196">
              <p className="text-white font-medium leading-relaxed mb-4" data-id="element-197">
                Es la sensación de que después de años dando clases, después de
                certificaciones, después de horas en pista y alumnos que mejoran
                de verdad, todavía llegás al domingo con la misma pregunta de
                siempre:
              </p>
              <p className="text-2xl sm:text-3xl font-display font-bold text-padel-lime mt-6" data-id="element-198">
                ¿Qué hago la semana que viene?
              </p>
            </div>

            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-199">
              Y ahí empieza el ciclo. Abrís el celular. Buscás en Instagram.
              Revisás videos de YouTube. Copiás algo que viste en un grupo de
              WhatsApp de profes. Armás algo que "más o menos sirve". Y el
              domingo que era para descansar se convierte en otra jornada de
              trabajo no pago que nadie ve y que nadie valora.
            </p>

            <p className="text-gray-300 leading-relaxed font-bold mb-12" data-id="element-200">
              Incluyendo vos.
            </p>

            <div className="text-center mb-12" data-id="element-201">
              <h2 className="text-3xl sm:text-4xl font-display font-bold text-white mb-4" data-id="element-202">
                El problema no es tu nivel. <br className="hidden sm:block" data-id="element-203" />
                <span className="text-padel-lime" data-id="element-204">
                  Es que nadie te dio el sistema.
                </span>
              </h2>
              <p className="text-gray-400" data-id="element-205">
                Te formaste para enseñar pádel. No para ser:
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-12" data-id="element-206">
              {['Director técnico', 'Planificador anual', 'Diseñador de sesiones', 'Evaluador de alumnos', 'Gestor de negocio'].map((role, i) => <div key={i} className="bg-padel-dark border border-padel-muted p-4 rounded-lg text-center flex items-center justify-center" data-id="element-207">
                  <span className="font-medium text-gray-200" data-id="element-208">{role}</span>
                </div>)}
            </div>

            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-209">
              Pero eso es exactamente lo que te pide la realidad de dar clases.
            </p>
            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-210">
              Y sin un sistema que sostenga todo eso, el resultado es siempre el
              mismo:{' '}
              <strong className="text-white" data-id="element-211">
                improvisación crónica, carga mental acumulada y la sensación de
                que trabajás mucho más de lo que ganás.
              </strong>
            </p>
            <p className="text-gray-300 leading-relaxed" data-id="element-212">
              No es debilidad. No es falta de vocación. Es que estás haciendo el
              trabajo de cinco roles distintos sin las herramientas para ninguno
              de los cinco.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}